import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import en from "./locales/en.json";
import tr from "./locales/tr.json";
import he from "./locales/he.json";
import ar from "./locales/ar.json";
import siteEn from "./locales/site/en.json";
import siteTr from "./locales/site/tr.json";
import siteHe from "./locales/site/he.json";
import siteAr from "./locales/site/ar.json";

export const LANGUAGES = [
  { code: "en", label: "English", dir: "ltr" },
  { code: "tr", label: "Türkçe", dir: "ltr" },
  { code: "he", label: "עברית", dir: "rtl" },
  { code: "ar", label: "العربية", dir: "rtl" },
];

export const RTL_LANGS = ["he", "ar"];
export const dirFor = (lang) => (RTL_LANGS.includes(lang) ? "rtl" : "ltr");

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: { ...en, site: siteEn } },
      tr: { translation: { ...tr, site: siteTr } },
      he: { translation: { ...he, site: siteHe } },
      ar: { translation: { ...ar, site: siteAr } },
    },
    fallbackLng: "en",
    supportedLngs: ["en", "tr", "he", "ar"],
    detection: { order: ["localStorage", "navigator"], lookupLocalStorage: "drivons_lang", caches: ["localStorage"] },
    interpolation: { escapeValue: false },
  });

export default i18n;
